import { Card, Col, Layout, Row, Segmented, Collapse, Flex, Divider } from "antd";
import { Content } from "antd/es/layout/layout";

import { useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "../styles/CardInfo.module.css";
import { useMediaQuery } from 'react-responsive';
import { useNavigate } from "react-router-dom";
import { RightOutlined } from "@ant-design/icons";

function CardInfo({
  getCardInfo = () => { },
  getCalendar = () => { },
  getAnnouncement = () => { },
  getPolicyAnnouncement = () => { },
  getGreeting = () => { },
  getTodayWorkSummary = () => { },
  getQuickActions = () => { },
  getTeamToday = () => { },
  getTeamTotal = () => 0,
  getPaddingList = () => { },
  getPendingTotal = () => 0,
  getVisaPermit = () => { },
  selectedDetailDate = null,
  getVisaPermitSegmentedExtra = () => null,
  getSelectedDayDetail = () => { },
  getLeaveRightsSummary = () => { },
  dayRequestModal = () => { },
  getNewsAndPolicyList = () => { },
  getShiftSummary = () => { },
  getDayNoteEditor = null,
  dynamicCalendarScale = 0.82,
  needsSixthRow = true,
  isHr = false,
}) {
  const { t } = useTranslation();
  const [segmented, setSegmented] = useState("news");
  const isOverScreen = useMediaQuery({ maxWidth: 1000 });
  const navigate = useNavigate();

  const CALENDAR_SCALED_HEIGHT = 210;
  const CALENDAR_BOX_HEIGHT = 248;
  const CARD_ROW_HEIGHT = 330;
  const compensateScale = 1 / dynamicCalendarScale;
  const segmentedOptions = [
    { label: t('news.header'), value: 'news' },
    { label: t('policy.header'), value: 'policy' }
  ];

  const cardExtraLink = (onClick) => (
    <span style={{ color: "#009DE6", cursor: "pointer", fontSize: 12 }} onClick={onClick}>
      {t('home.btn.view-all')}
    </span>
  );

  const newsItems = [
    {
      key: '1',
      label: t('home.announcement.title'),
      extra: (
        <Segmented className={styles.customSegmented} options={segmentedOptions} value={segmented} onChange={setSegmented} />
      ),
      children: (
        <Flex vertical style={{ height: segmented === "news" ? "auto" : "220px", overflowY: segmented === "news" ? "hidden" : "auto", scrollbarWidth: "thin" }}>
          {segmented === "news" ? getAnnouncement(segmented) : getPolicyAnnouncement(segmented)}
        </Flex>
      ),
    },
  ];

  const fixedWrapperStyle = (h) => !isOverScreen
    ? { width: "100%", height: h, overflow: "hidden" }
    : { width: "100%" };

  const fixedCardStyle = {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
  };

  const fixedBodyStyle = {
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    scrollbarWidth: "thin",
  };

  return (
    <Layout style={{ backgroundColor: "transparent" }}>

      {/* Top bar */}
      <Content style={{ marginBottom: "8px", backgroundColor: "transparent" }}>
        <Row gutter={10}>
          <Col span={isOverScreen ? 24 : 16} style={{ marginBottom: isOverScreen ? 10 : 0 }}>
            <Card bordered={false} className={styles.compactCard} style={{ height: "100%" }}>
              <Row style={{ alignItems: "stretch", height: "100%", flexWrap: "nowrap" }}>
                <Col
                  flex={isOverScreen ? "1 1 100%" : "10 1 0%"}
                  style={{
                    minWidth: isOverScreen ? undefined : 0,
                    display: "flex",
                    alignItems: "center",
                    transform: isOverScreen ? "none" : "translate(0px, 0px)",
                  }}
                >
                  {getCardInfo()}
                </Col>

                {!isOverScreen && (
                  <Col flex="0 0 auto" style={{ display: "flex", alignItems: "stretch" }}>
                    <Divider type="vertical" style={{ height: "auto", alignSelf: "stretch", margin: "0 24px" }} />
                  </Col>
                )}

                <Col
                  flex={isOverScreen ? "1 1 100%" : "11 1 0%"}
                  style={{
                    minWidth: isOverScreen ? undefined : 0,
                    marginTop: isOverScreen ? 16 : 0,
                    display: "flex",
                    alignItems: "center",
                    transform: isOverScreen ? "none" : "translateY(12px)",
                  }}
                >
                  <Flex vertical gap={8} style={{ width: "100%" }}>
                    <span style={{ fontWeight: "bold" }}>{t("home.today-work.title")}</span>
                    {getTodayWorkSummary()}
                  </Flex>
                </Col>

                {!isOverScreen && (
                  <Col flex="0 0 auto" style={{ display: "flex", alignItems: "stretch" }}>
                    <Divider type="vertical" style={{ height: "auto", alignSelf: "stretch", margin: "0 24px" }} />
                  </Col>
                )}

                <Col
                  flex={isOverScreen ? "1 1 100%" : "3 1 0%"}
                  style={{
                    minWidth: isOverScreen ? undefined : 0,
                    marginTop: isOverScreen ? 16 : 0,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {getShiftSummary()}
                </Col>
              </Row>
            </Card>
          </Col>

          <Col span={isOverScreen ? 24 : 8}>
            <Card
              title={t("home.quick-actions.title")}
              bordered={false}
              className={styles.compactCard}
              style={{ height: "100%" }}
              styles={{
                body: { padding: 12 },
                header: { borderBottom: "none" },
              }}
            >
              {getQuickActions()}
            </Card>
          </Col>
        </Row>
      </Content>

      <Content style={{ marginBottom: "10px", backgroundColor: "transparent" }}>
        <Row gutter={10}>
          <Col span={isOverScreen ? 24 : 8} style={{ marginBottom: isOverScreen ? 10 : 0 }}>
            <div style={fixedWrapperStyle(CARD_ROW_HEIGHT)}>
              <Card
                bordered={false}
                size="small"
                className={styles.compactCard}
                style={fixedCardStyle}
                styles={{
                  body: {
                    padding: "8px 12px",
                    display: "flex",
                    flexDirection: "column",
                  },
                }}
              >
                <Row gutter={16}>
                  <Col span={selectedDetailDate ? 14 : 24}>
                    <div
                      className={styles.compactCalendar}
                      style={
                        selectedDetailDate
                          ? {
                            height: CALENDAR_SCALED_HEIGHT,
                            overflow: "hidden",
                          }
                          : undefined
                      }
                    >
                      <div
                        className={selectedDetailDate ? styles.compactScaled : ""}
                        style={
                          selectedDetailDate
                            ? {
                              transform: `scaleY(${dynamicCalendarScale})`,
                              transformOrigin: "top",
                              "--compensate-scale": compensateScale,
                            }
                            : undefined
                        }
                      >
                        {getCalendar()}
                      </div>
                    </div>
                  </Col>
                  {selectedDetailDate && (
                    <Col span={10} style={{ paddingRight: 0 }}>
                      {getSelectedDayDetail()}
                    </Col>
                  )}
                </Row>

                {selectedDetailDate && (
                  <div style={{ flexShrink: 0, marginTop: 4 }}>
                    {getDayNoteEditor()}
                  </div>
                )}
              </Card>
            </div>
          </Col>

          <Col span={isOverScreen ? 24 : 8} style={{ marginBottom: isOverScreen ? 10 : 0 }}>
            <div style={fixedWrapperStyle(CARD_ROW_HEIGHT)}>
              <Card
                bordered={false}
                className={styles.compactCard}
                style={fixedCardStyle}
                styles={{ body: fixedBodyStyle }}
                title={
                  <span>
                    {t('home.pending-request-list.title')}{" "}
                    <span style={{ color: "#98A2B3", fontWeight: 400 }}>
                      {getPendingTotal()} {t("unit.item")}
                    </span>
                  </span>
                }
                extra={cardExtraLink(() => navigate("/my_document/my_request"))}
              >
                {getPaddingList()}
              </Card>
            </div>
          </Col>

          <Col span={isOverScreen ? 24 : 8}>
            <div style={fixedWrapperStyle(CARD_ROW_HEIGHT)}>
              <Card
                title={t('home.remaining-leave-benefits.title')}
                bordered={false}
                className={styles.compactCard}
                style={fixedCardStyle}
                styles={{ body: fixedBodyStyle }}
              >
                {getLeaveRightsSummary()}
              </Card>
            </div>
          </Col>
        </Row>
      </Content>

      <Content style={{ backgroundColor: "transparent" }}>
        <Row gutter={10} align="stretch">
          {getTeamTotal() > 0 && (
            <Col span={isOverScreen ? 24 : 8} style={{ marginBottom: isOverScreen ? 10 : 0, display: "flex" }}>
              <div style={fixedWrapperStyle(CARD_ROW_HEIGHT)}>
                <Card
                  title={t('home.team.title')}
                  bordered={false}
                  className={styles.compactCard}
                  style={fixedCardStyle}
                  styles={{ body: { flex: 1, minHeight: 0, overflow: "hidden", padding: "10px 12px" } }}
                  extra={
                    <span style={{ color: "#98A2B3", fontWeight: 400, fontSize: 12 }}>
                      {t('home.team.total-count', { count: getTeamTotal() })}
                    </span>
                  }
                >
                  {getTeamToday()}
                </Card>
              </div>
            </Col>
          )}

          {isHr && (
            <Col span={isOverScreen ? 24 : 8} style={{ marginBottom: isOverScreen ? 10 : 0, display: "flex" }}>
              <div style={fixedWrapperStyle(CARD_ROW_HEIGHT)}>
                <Card
                  title="Visa & Work Permit"
                  bordered={false}
                  className={styles.compactCard}
                  style={fixedCardStyle}
                  styles={{ body: fixedBodyStyle }}
                  extra={getVisaPermitSegmentedExtra()}
                >
                  {getVisaPermit()}
                </Card>
              </div>
            </Col>
          )}
          <Col span={isOverScreen ? 24 : 8} style={{ display: "flex" }}>
            <div style={fixedWrapperStyle(CARD_ROW_HEIGHT)}>
              <Card
                title={t("home.news-policy.title")}
                bordered={false}
                className={styles.compactCard}
                style={fixedCardStyle}
                styles={{ body: fixedBodyStyle }}
                extra={cardExtraLink(() => navigate("/news_list"))}
              >
                {getNewsAndPolicyList()}
              </Card>
            </div>
          </Col>
        </Row>
      </Content>
      {dayRequestModal()}
    </Layout>
  );
}

export default CardInfo;